<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <div class="settlement-summary">
      <div class="settlement-summary__label">结算总计</div>
      <div class="settlement-summary__amount">{{ formatAmount(settlementTotal) }} 元</div>
    </div>
    <div class="settlement-view-section settlement-view-section--normal">
      <div class="settlement-view-section__header">
        <span>正常结算</span>
        <strong>小计：{{ formatAmount(normalSettlementTotal) }} 元</strong>
      </div>
      <table class="settlement-table">
        <thead>
          <tr>
            <th>结算条目</th>
            <th>单价（元）</th>
            <th>门店数量</th>
            <th>小计（元）</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in settlementForm.normal_settled_list"
              :key="'normal-' + index">
            <td>{{ item.settlement_item }}</td>
            <td>{{ item.unit_price }}</td>
            <td>{{ item.store_count }}</td>
            <td>{{ item.subtotal }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="settlement-view-section settlement-view-section--abnormal">
      <div class="settlement-view-section__header">
        <span>异常作废</span>
        <strong>小计：{{ formatAmount(abnormalSettlementTotal) }} 元</strong>
      </div>
      <table class="settlement-table">
        <thead>
          <tr>
            <th>结算条目</th>
            <th>单价（元）</th>
            <th>门店数量</th>
            <th>小计（元）</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in settlementForm.abnormal_voided_list"
              :key="'abnormal-' + index">
            <td>{{ item.settlement_item }}</td>
            <td>{{ item.unit_price }}</td>
            <td>{{ item.store_count }}</td>
            <td>{{ item.subtotal }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="detail-table">
      <tbody>
        <tr v-if="settlementForm.other_extra">
          <td class="label-col">其他补充</td>
          <td>{{ settlementForm.other_extra }}</td>
        </tr>
        <tr>
          <td class="label-col">备注</td>
          <td>{{ settlementForm.file_remarks }}</td>
        </tr>
        <tr>
          <td class="label-col">附件</td>
          <td>
            <AttachmentViewer :files="settlementForm.project_report_files"></AttachmentViewer>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AttachmentViewer from '@views/project/node-views/AttachmentViewer.vue'
import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'
import { hydrateProjectReportForm, sumSettlementSubtotal } from '@views/project/project-report-settlement'

export default {
  components: {HistoryLogCom, AttachmentViewer},
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    },
  },
  computed: {
    settlementForm () {
      return hydrateProjectReportForm(_.get(this.fullNode, 'project_node.node_result', {}))
    },
    normalSettlementTotal () {
      return sumSettlementSubtotal(this.settlementForm.normal_settled_list)
    },
    abnormalSettlementTotal () {
      return sumSettlementSubtotal(this.settlementForm.abnormal_voided_list)
    },
    settlementTotal () {
      return this.normalSettlementTotal + this.abnormalSettlementTotal
    },
  },
  methods: {
    formatAmount (value) {
      const numberValue = Number(value) || 0
      return numberValue.toLocaleString('zh-CN', {maximumFractionDigits: 2})
    },
  },
}
</script>

<style scoped>
.settlement-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding: 18px 20px;
  border: 1px solid #d7e7ff;
  border-radius: 6px;
  background: #edf4ff;
}

.settlement-summary__label {
  color: #667085;
  font-weight: bold;
}

.settlement-summary__amount {
  color: #2f66e8;
  font-size: 24px;
  font-weight: bold;
}

.settlement-view-section {
  margin-top: 15px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.settlement-view-section--normal {
  border-color: #d7f0dd;
}

.settlement-view-section--abnormal {
  border-color: #f3dfcb;
}

.settlement-view-section__header {
  display: flex;
  justify-content: space-between;
  padding: 12px 14px;
  color: #303133;
  font-weight: bold;
}

.settlement-view-section--normal .settlement-view-section__header {
  background: #eefbf2;
}

.settlement-view-section--abnormal .settlement-view-section__header {
  background: #fff5e8;
}

.settlement-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.settlement-table th,
.settlement-table td {
  padding: 10px 12px;
  border-top: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
  text-align: left;
}

.settlement-table th {
  background: #fafafa;
  color: #667085;
  font-weight: bold;
}

.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}

.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}

.detail-table .label-col {
  width: 100px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/UploadProjectReportView.vue